export default [
	// {
	// 	type: 'talisman',
	// 	slug: 'fork',
	// 	price: 10,
	// 	rarity: 'common',
	// 	triggers: [],
	// 	fr: {
	// 		name: "Fourchette",
	// 		description: "Attaque de base +1."
	// 	}, 
	// 	en: {
	// 		name: "Fork",
	// 		description: "Attack +1"
	// 	}
	// },
	{
		type: 'talisman',
		slug: 'flower',
		price: null,
		rarity: 'common',
		triggers: [],
		fr: {
			name: "Fleur",
			description: "Point de vie max +1."
		}, 
		en: {
			name: "Flower",
			description: "Max health +1"
		}
	},
	{
		type: 'talisman',
		slug: 'goldsun-brooch',
		price: 10,
		rarity: 'common',
		triggers: [],
		fr: {
			name: "Broche Soleil en or",
			description: "Confère +1 aux cartes émeraude."
		}, 
		en: {
			name: "Gold Sun Brooch",
			description: "Gives +1 to emerald cards."
		}
	},
	{
		type: 'talisman',
		slug: 'zombie-hand',
		price: 10,
		rarity: 'common',
		triggers: [],
		fr: {
			name: "Main de zombie",
			description: "Confère +1 aux cartes potion de soin et potion de poison."
		}, 
		en: {
			name: "Zombie hand",
			description: "Gives +1 to health potion et potion of poison cards."
		}
	},
	{
		type: 'talisman',
		slug: 'asticot',
		price: 14,
		rarity: 'rare',
		triggers: [{
			on: 'get-status-poison',
			method: 'give',
			strength: 1
		}],
		fr: {
			name: "Asticot",
			description: "Lorsque vous recevez (poison)[status-poison] vous recevez également (force 1)[status-strength:1]"
		}, 
		en: {
			name: "Asticot",
			description: "When you receive (poison)[status-poison], you also receive (force 1)[status-strength:1]."
		}
	},
	{
		type: 'talisman',
		slug: 'gold-tooth',
		price: 14,
		rarity: 'rare',
		triggers: [{
			on: 'play-card-scroll',
			method: 'give',
			gold: 1
		}],
		fr: {
			name: "Dent en or",
			description: "Lorsque vous jouez une carte parchemin, recevez 1 émeraude."
		}, 
		en: {
			name: "Golden tooth",
			description: "When you play a scroll card, receive 1 emerald."
		}
	},
	{
		type: 'talisman',
		slug: 'baby-bird',
		price: 14,
		rarity: 'rare',
		triggers: [],
		fr: {
			name: "Bébé oiseau",
			description: "Réduit l'attaque des ennemis de 1 si vous n'avez pas d'équipement."
		}, 
		en: {
			name: "Baby bird",
			description: "Reduces enemy attack by 1 if you have no equipment."
		}
	},
	{
		type: 'talisman',
		slug: 'shell',
		price: 14,
		rarity: 'rare',
		triggers: [{
			on: 'before-fight',
			if: 'no-equipments',
			method: 'add_equipment',
			equipment: 'wooden-shield'
		}],
		fr: {
			name: "Coquillage",
			description: "Si vous n'avez pas d'équipement en commençant un combat, vous recevez un bouclier en bois."
		}, 
		en: {
			name: "Shell",
			description: "If you don't have any equipment when you start a fight, you receive a wooden shield."
		}
	},
	{
		type: 'talisman',
		slug: 'ring',
		price: 10,
		rarity: 'common',
		triggers: [],
		fr: {
			name: "Bague",
			description: "Réduit le prix des talismans de 3 émeraudes."
		}, 
		en: {
			name: "Ring",
			description: "Reduces the price of talismans by 3 emeralds."
		}
	},
	{
		type: 'talisman',
		slug: 'chalice',
		price: 10,
		rarity: 'common',
		triggers: [{
			on: 'heal',
			method: 'give',
			gold: 1 
		}],
		fr: {
			name: "Calice",
			description: "Lorsque vous êtes soigné, recevez 1 émeraude."
		}, 
		en: {
			name: "Golden chalice",
			description: "When you are healed, receive 1 emerald."
		}
	},
	{
		type: 'talisman',
		slug: 'gnome',
		price: 18,
		rarity: 'legendary',
		triggers: [],
		fr: {
			name: "Gnome",
			description: "Ajoute 1 carte à votre main."
		}, 
		en: {
			name: "Gnome",
			description: "Adds 1 card to your hand."
		}
	},
	{
		type: 'talisman',
		slug: 'wounded-heart',
		price: 18,
		rarity: 'legendary',
		triggers: [],
		fr: {
			name: "Coeur blessé",
			description: "Confère +1 d'attaque aux cartes arme."
		}, 
		en: {
			name: "Wounded heart",
			description: "Gives +1 attack to weapon cards."
		}
	},
	{
		type: 'talisman',
		slug: 'keeps',
		price: 18,
		rarity: 'legendary',
		triggers: [],
		fr: {
			name: "Conserve",
			description: "Confère +1 de durabilité aux cartes arme."
		}, 
		en: {
			name: "Keeps",
			description: "Gives +1 durability to weapon cards."
		}
	},
	{
		type: 'talisman',
		slug: 'amphora',
		price: 14,
		rarity: 'rare',
		triggers: [],
		fr: {
			name: "Amphore",
			description: "Confère +1 de durabilité aux cartes bouclier."
		}, 
		en: {
			name: "Ampora",
			description: "Gives +1 durability to shield cards."
		}
	},
	{
		type: 'talisman',
		slug: 'head-in-head',
		price: 14,
		rarity: 'rare',
		triggers: [{
			on: 'receive-gold',
			method: 'heal',
			value: 1,
			probability: 10
		}],
		fr: {
			name: "Tête dans une tête",
			description: "Lorsque vous recevez des émeraudes, vous avez 10% de chance de vous soigner 1 point de vie."
		}, 
		en: {
			name: "Head in head",
			description: "When you receive emeralds, you have a 10% chance to heal yourself 1 health point."
		}
	},
	{
		type: 'talisman',
		slug: 'pyramidal-fruit',
		price: 14,
		rarity: 'rare',
		triggers: [{
			on: 'get-card-poison-potion',
			method: 'heal',
			value: 1
		}],
		fr: {
			name: "Fruit pyramidale",
			description: "Les cartes potions de poison vous soigne 1 point de vie."
		}, 
		en: {
			name: "Pyramidal fruit",
			description: "Potion of poison heal you 1 health point."
		}
	},
	{
		type: 'talisman',
		slug: 'fish-head',
		price: 10,
		rarity: 'common',
		triggers: [{
			on: 'get-card-poison-potion',
			method: 'deal_damage_to_adjacent_enemy',
			value: 2
		}],
		fr: {
			name: "Tête de poisson",
			description: "Les cartes potions de poison inflige 2 dégâts à l'ennemi adjacent."
		}, 
		en: {
			name: "Fish head",
			description: "Potion of poison inflict 3 damage to the adjacent enemy."
		}
	},
	{
		type: 'talisman',
		slug: 'letter',
		price: 14,
		rarity: 'rare',
		triggers: [{
			on: 'get-card-poison-potion',
			method: 'give_card',
			card_type: 'scroll'
		}],
		fr: {
			name: "Lettre",
			description: "Les potions de poison vous donne une carte parchemin aléatoire en main."
		}, 
		en: {
			name: "Letter",
			description: "Potion of poison gives you a random scroll card in your hand."
		}
	},
	{
		type: 'talisman',
		slug: 'shop-dice',
		price: 10,
		rarity: 'common',
		triggers: [],
		fr: {
			name: "Dé de marchand",
			description: "Réduit le prix des rerolls du marchand de 2 émeraudes."
		}, 
		en: {
			name: "Merchant dice",
			description: "Reduces the price of the merchant's reroll by 2 emeralds."
		}
	},
	{
		type: 'talisman',
		slug: 'hand-dice',
		price: 10,
		rarity: 'rare',
		triggers: [],
		fr: {
			name: "Dé de héros",
			description: "Réduit le prix des rerolls de la main de 1 émeraude."
		}, 
		en: {
			name: "Hero dice",
			description: "Reduces the price of your hand's reroll by 1 emerald."
		}
	},
]